function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React, { Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { dataLayer } from '@finect/front-gtm';
import { slugify } from '@finect/front-utils/slugify';
import { Modal } from '../Modal';
import { Tabs } from '../Tabs';
import { Inner, Footer, Header, TabsBlock } from './partials';
import { Subsections } from './Subsections';
import { getChildren } from './utils';
export var Section = function (_React$Component) {
  _inherits(Section, _React$Component);
  var _super = _createSuper(Section);
  function Section() {
    var _this;
    _classCallCheck(this, Section);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      expanded: false,
      activeSubsectionId: 0
    });
    _defineProperty(_assertThisInitialized(_this), "getExpandedHash", function () {
      var id = _this.props.id || (_this.props.title ? slugify(_this.props.title) : null);
      return id ? "#expand-".concat(id) : null;
    });
    _defineProperty(_assertThisInitialized(_this), "handleExpandClick", function () {
      var _this$props$id = _this.props.id,
        id = _this$props$id === void 0 ? 'default' : _this$props$id;
      _this.setState({
        expanded: !_this.state.expanded
      });
      _this.getExpandedHash() && _this.props.history.push(_this.getExpandedHash());
      dataLayer({
        id: 'SectionExpand',
        type: 'click',
        params: {
          id: "section-".concat(id)
        }
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleExpandClose", function () {
      _this.setState({
        expanded: false
      });
      _this.getExpandedHash() && _this.props.history.goBack();
    });
    _defineProperty(_assertThisInitialized(_this), "handleSubsectionChange", function (id) {
      _this.setState({
        activeSubsectionId: id
      });
    });
    return _this;
  }
  _createClass(Section, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      if (!this.getExpandedHash()) {
        return;
      }
      if (!this.state.expanded && this.props.location.hash === this.getExpandedHash()) {
        this.setState({
          expanded: true
        });
      }
      this.props.history.listen(function (event) {
        if (_this2.state.expanded) {
          _this2.setState({
            expanded: false
          });
        }
        if (!_this2.state.expanded && event.hash === _this2.getExpandedHash()) {
          _this2.setState({
            expanded: true
          });
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var _this$props = this.props,
        id = _this$props.id,
        titleVariant = _this$props.titleVariant,
        title = _this$props.title,
        subtitle = _this$props.subtitle,
        subtitleVariant = _this$props.subtitleVariant,
        expandedPosition = _this$props.expandedPosition,
        topMargin = _this$props.topMargin,
        bottomMargin = _this$props.bottomMargin,
        headerLink = _this$props.headerLink,
        size = _this$props.size,
        selectProps = _this$props.selectProps,
        link = _this$props.link,
        linkAlign = _this$props.linkAlign,
        links = _this$props.links,
        linksVariant = _this$props.linksVariant,
        linksInitial = _this$props.linksInitial,
        withBorder = _this$props.withBorder,
        expandedCloseActionVisible = _this$props.expandedCloseActionVisible,
        actions = _this$props.actions,
        expandedActionText = _this$props.expandedActionText;
      var activeSubsectionId = this.state.activeSubsectionId;
      var subsectionChildren = getChildren(this.props.children, 'Subsection', true);
      var footerChildren = getChildren(this.props.children, 'SectionFooter', true);
      var sectionChildren = getChildren(this.props.children, 'Expanded', false);
      var expandedChildren = getChildren(this.props.children, 'Expanded', true);
      var hasExpandedView = expandedChildren.length;
      var _expandedChildren = _slicedToArray(expandedChildren, 1),
        expanded = _expandedChildren[0];
      var expandedVariant = expanded ? expanded.props.variant || 'fullScreen' : 'fullScreen';
      return React.createElement(React.Fragment, null, React.createElement(Modal, {
        variant: expandedVariant,
        zIndex: 100000,
        show: this.state.expanded,
        onClose: this.handleExpandClose,
        scrollLock: false,
        closeActionVisible: expandedCloseActionVisible
      }, React.Children.map(expandedChildren, function (child) {
        return React.cloneElement(child, {
          onCloseExpand: _this3.handleExpandClose
        });
      })), React.createElement(Inner, {
        topMargin: topMargin,
        bottomMargin: bottomMargin,
        size: size,
        withBorder: withBorder
      }, id ? React.createElement("a", {
        id: id
      }) : null, React.createElement(Header, {
        size: size,
        link: headerLink,
        title: title,
        titleVariant: titleVariant || 'default',
        subtitle: subtitle,
        subtitleVariant: subtitleVariant || 'default',
        onExpand: hasExpandedView && expandedPosition === 'header' ? this.handleExpandClick : null,
        expandedActionText: expandedActionText,
        subsections: subsectionChildren.map(function (item, index) {
          return {
            id: index,
            name: item.props.name
          };
        }),
        activeSubsectionId: activeSubsectionId,
        selectProps: selectProps,
        onSubsectionChange: this.handleSubsectionChange
      }), links.length ? React.createElement(TabsBlock, null, React.createElement(Tabs, {
        variant: linksVariant || 'links',
        initial: linksInitial,
        color: "primaryM",
        titleColor: "primary",
        tabs: links.map(function (item) {
          return {
            title: item.text,
            link: _objectSpread(_objectSpread({}, item), {}, {
              href: item.href || item.to
            })
          };
        })
      })) : null, subsectionChildren.length ? React.createElement(Subsections, {
        subsections: subsectionChildren,
        active: activeSubsectionId,
        onSubsectionChange: this.handleSubsectionChange
      }) : React.createElement("div", null, sectionChildren), footerChildren.length ? React.createElement("div", null, footerChildren) : null, React.createElement(Footer, {
        actions: actions,
        link: link,
        linkAlign: linkAlign,
        onExpand: hasExpandedView && ['footer'].includes(expandedPosition) ? this.handleExpandClick : null,
        expandedActionText: expandedActionText
      })));
    }
  }]);
  return Section;
}(React.Component);
_defineProperty(Section, "defaultProps", {
  titleVariant: 'default',
  expandedPosition: 'footer',
  topMargin: false,
  bottomMargin: false,
  headerLink: null,
  expandedCloseActionVisible: true,
  actions: [],
  linkAlign: 'left',
  links: [],
  linksInitial: 0,
  size: 'large',
  expandedActionText: 'Expandir'
});
export default React.memo(withRouter(Section));